// API Configuration
// This file handles environment-based API URL configuration

const getApiBaseUrl = () => {
  // Force Railway API URL for all environments
  return 'https://agti-python-dev.up.railway.app';
};

const API_CONFIG = {
  BASE_URL: getApiBaseUrl(),
  TIMEOUT: 60000,
  ENDPOINTS: {
    HEALTH: '/health',
    ANALYZE: '/api/analyze',
    MESSAGES: '/api/messages',
    STATISTICS: '/api/statistics',
    MERKLE_ROOT: '/api/merkle/root',
    RULES: '/api/rules',
    BLOCKCHAIN_CONTRACT: '/api/blockchain/contract',
    BLOCKCHAIN_EXPLORER: '/api/blockchain/explorer',
    BLOCKCHAIN_COMPLETION_EXPLORER: '/api/blockchain/completion-explorer',
  }
};

// Helper function to get full URL for an endpoint
export const getApiUrl = (endpoint) => {
  return `${API_CONFIG.BASE_URL}${endpoint}`;
};

// Helper function to get environment info
export const getEnvironmentInfo = () => {
  return {
    environment: 'production',
    apiBaseUrl: API_CONFIG.BASE_URL,
    isProduction: true,
    isDevelopment: false,
  };
};

export default API_CONFIG; 